import React, { createContext, useContext, useEffect, useState, useCallback, useMemo, useRef } from 'react';
import { useAuth } from './AuthContext';

const SocketContext = createContext(null);

// Simple real-time context - Socket.IO has connection issues in this environment
export const SocketProvider = ({ children }) => {
  const [connected, setConnected] = useState(true);
  const listenersRef = useRef({});
  const { token } = useAuth();

  useEffect(() => {
    if (token) {
      setConnected(true);
    }
  }, [token]);

  // Memoized socket object to prevent infinite re-renders
  const socket = useMemo(() => ({
    on: (event, callback) => {
      if (!listenersRef.current[event]) {
        listenersRef.current[event] = [];
      }
      listenersRef.current[event].push(callback);
    },
    off: (event, callback) => {
      if (listenersRef.current[event]) {
        listenersRef.current[event] = listenersRef.current[event].filter(cb => cb !== callback);
      }
    },
    emit: (event, data) => {
      console.log('Socket emit:', event, data);
    }
  }), []);

  const joinRoom = useCallback((roomId) => {
    console.log('Join room:', roomId);
  }, []);

  const leaveRoom = useCallback((roomId) => {
    console.log('Leave room:', roomId);
  }, []);

  const emitTyping = useCallback((roomId, userName) => {
    console.log('Typing:', roomId, userName);
  }, []);

  const value = useMemo(() => ({
    socket,
    connected,
    joinRoom,
    leaveRoom,
    emitTyping
  }), [socket, connected, joinRoom, leaveRoom, emitTyping]);

  return (
    <SocketContext.Provider value={value}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};
